/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type StorefrontOnly_item = {
    readonly isStorefrontOnly: boolean | null;
    readonly " $refType": "StorefrontOnly_item";
};
export type StorefrontOnly_item$data = StorefrontOnly_item;
export type StorefrontOnly_item$key = {
    readonly " $data"?: StorefrontOnly_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontOnly_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontOnly_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isStorefrontOnly",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'bd19f05b83da40587f7adf343ba3b6ff';
export default node;
